import React from 'react';
import { DocumentationFile } from '../../../../graphql/graphql';
import ECardGridItem from './ECardGridItem';
import { FileToShare } from '../ECard/ECard';
import { ECardType } from '../../Enums/ECardType.enum';

interface Props {
	items: DocumentationFile[];
	reloadData: (folderId: string, needReload: boolean) => void;
	isShareMode: boolean;
	onItemCheck: (file: FileToShare, isChecked: boolean) => void;
	filesToShare: FileToShare[];
	eCardType: ECardType;
}

const ECardGrid: React.FC<Props> = ({
	items,
	reloadData,
	isShareMode,
	onItemCheck,
	filesToShare,
	eCardType,
}) => {
	return (
		<div className='row'>
			{items?.map(item => (
				<React.Fragment key={item.id}>
					<ECardGridItem
						item={item}
						reloadData={reloadData}
						isShareMode={isShareMode}
						onCheck={onItemCheck}
						isSelected={filesToShare.some(file => file.id === item.id)}
						canBeEdited={eCardType === ECardType.HEALTH_DOCUMENTATION}
					/>
				</React.Fragment>
			))}
		</div>
	);
};

export default ECardGrid;
